/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import "./Campaign.css";
import CampaignDetails from "../../Assets/Img/Form.png";
import Audience from "../../Assets/Img/People.png";
import Deliverables from "../../Assets/Img/Social Media.png";
import Overview from "../../Assets/Img/solar_checklist-outline.png";
import Compensationimg from "../../Assets/Img/Compensationimg.png";
import TargetAudienceimg from "../../Assets/Img/TargetAudienceimg.png";
import ExpectedDeliverablesimg from "../../Assets/Img/ExpectedDeliverablesimg.png";
import fileicon from "../../Assets/Img/fileicon.png";
import loadingGIF from "../../Assets/Img/loadingGIF.gif";
import Search from "../../Assets/Img/search.png";
import Heart from "../../Assets/Img/Heart.svg";
import HeartDark from "../../Assets/Img/HeartDark.svg";
import Filter from "../../Assets/Img/Filter.png";
import create from "../../Assets/Img/create dashboard.png";
import NoCamp from "../../Assets/Img/amico.svg";
import emptyinsights from "../../Assets/Img/insights.svg";
import DummyImg from "../../Assets/Img/Rectangle 21.png";
import { useNavigate } from "react-router-dom";
import axiosMain from "../../http/axiosMain";
import CalenderImg from "../../Assets/Img/calender.svg";
import LocationImg from "../../Assets/Img/Location.png";
import instaDeliverables from "../../Assets/Img/insta deliverables.svg";
import youtubeDeliverables from "../../Assets/Img/youtube deliverables.svg";
import { useLocation } from "react-router-dom";
import { Chip, Tooltip } from "@mui/material";
import { SearchBar } from "../../Common/Components/SearchBar";

export default function CampaignCreate() {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);

  const [showContent, setShowContent] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const location = useLocation();
  const [filteredData, setFilteredData] = useState(data);
  // const [activeTab, setActiveTab] = useState("recent");
  const [activeTab, setActiveTab] = useState(() => {
    return location.state?.activeTab || "completed";
  });
  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  const handleIncrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].count += 1;
    setContentTypes(newContentTypes);
  };

  const handleDecrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
    if (currentCount > 0) {
      newContentTypes[platformIndex].items[itemIndex].count -= 1;
      setContentTypes(newContentTypes);
    }
  };

  const handleCheckboxChange = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].checked =
      !newContentTypes[platformIndex].items[itemIndex].checked;
    setContentTypes(newContentTypes);
  };

  const handleNextbtn = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date when start date changes
    setShowContent(false);
  };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getUTCFullYear();

    return `${day} ${month}, ${year}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setLoading(true);
    setShowContent(false);

    setTimeout(() => {
      setLoading(false);
      setShowContent(true);
    }, 2000); // Show loader for 2 seconds
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };

  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };
  const [selectedAge, setSelectedAge] = useState(null);

  const ageGroups = [
    "13-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
  ];

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSaveDraft = () => {
    // Log save draft response here
    console.log("Draft Saved:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };

  const handlePublish = () => {
    // Log publish response here
    console.log("Campaign Published:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };
  const Insights = (campaignId) => {
    navigate(`/Insights`); // Replace `/insights/` with your desired route
  };
  const ViewDetails = (id) => {
    navigate(`/campaign-details/${id}`);
  };

  const navigate = useNavigate();
  const createNavigate = () => {
    navigate("/campaign-create");
  };

  const [error, setError] = useState(null);
  // Dhruv Rajpurohit
  useEffect(() => {
    setActiveTab("completed"); // Ensure "completed" is the default when the page loads
  }, []);
  // Dhruv Rajpurohit

  const fetchData = async () => {
    try {
      const response = await axiosMain.get("/api/v1/campaigns");
      setData(response.data.campaigns);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false); // Ensure loading state is updated
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);
  if (loading) {
    return <div>Loading...</div>; // Display a loading message or spinner
  }

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const recentCampaigns = data?.filter(
    (ele) => ele.camping_created_date.split("T")[0] === today
  );
  const draftCampaigns = data?.filter((ele) => ele.issavedasdraft === 1);

  const scheduledCampaigns = data?.filter((ele) => {
    const startDate = ele?.start_date?.split("T")[0];
    return startDate > today; // Future campaigns
  });
  const ongoingCampaigns = data?.filter((ele) => {
    const startDate = ele?.start_date?.split("T")[0];
    const endDate = ele?.end_date?.split("T")[0];
    return startDate <= today && today <= endDate; // Currently running campaigns
  });
  const completedCampaigns = data?.filter((ele) => {
    const endDate = ele?.end_date?.split("T")[0];
    return (
      ele?.flag_campaign_finished === true || // ✅ finished via button
      endDate < today // ✅ finished via date
    );
  });

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query?.length > 0) {
      const filtered = data.filter((campaign) =>
        campaign.campaign_title?.toLowerCase().includes(query.toLowerCase())
      );
      setData(filtered);
    } else {
      fetchData();
    }
  };
  const handleAddDeliverablesClick = () => {
    navigate("/insights-deliverable");
  };

  return (
    <div className="campaignCreate">
      {data?.length > 0 && (
        <div className="SearchFilterSection">
          <div className="d-flex justify-content-end align-items-center w-100">
            {completedCampaigns?.length === 0 ? (
              <></>
            ) : (
              <div div className="SearchInput">
                <SearchBar
                  searchQuery={searchQuery}
                  setSearchQuery={handleSearch}
                />
              </div>
            )}
            {/* Conditionally render Filters and Reset Filters buttons */}

            {/* <div>
              <button>
                Filters{" "}
                <img src={Filter} className="img-fluid" alt="Filter Icon" />
              </button>
              <button>Reset Filters</button>
            </div> */}
          </div>
        </div>
      )}

      {data?.length > 0 ? (
        <div className="CreatedCampaigns mt-4">
          <ul className="nav nav-tabs mb-4">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "completed" ? "active" : ""
                }`}
                onClick={() => setActiveTab("completed")}
              >
                Completed Campaigns ({completedCampaigns?.length || 0})
              </button>
            </li>
          </ul>

          <div className="tab-content">
            {/* Recently Created Campaigns */}
            {activeTab === "recent" && (
              <div className="row g-4">
                {recentCampaigns?.map((ele) => {
                  const cities = Array.isArray(ele.city)
                    ? ele.city
                    : typeof ele.city === "string"
                      ? [ele.city]
                      : [];

                  const states = Array.isArray(ele.state)
                    ? ele.state
                    : typeof ele.state === "string"
                      ? [ele.state]
                      : [];

                  const locations = cities.map((city, index) => ({
                    city,
                    state: states[index] || "",
                  }));
                  return (
                    <div
                      key={ele.campaign_id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      <div className="campaign-card">
                        <div className="influencer-home-image">
                          <img
                            src={ele.campaign_poster || DummyImg}
                            alt={ele.campaign_title}
                            className="campaign-image w-100"
                          />
                        </div>
                        <div className="p-3">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="StatusCamp">
                              <Tooltip title={ele.campaign_title}>
                                <h5 className="mb-1 campaign-title">
                                  {ele?.campaign_title
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                    ele?.campaign_title?.slice(1)}
                                </h5>
                              </Tooltip>
                              <span className="">
                                <div className="">
                                  {ele?.camping_created_date === today
                                    ? "Ongoing"
                                    : ""}
                                </div>
                              </span>
                            </div>
                          </div>
                          <p className="mb-2">{ele?.campaign_obj}</p>
                          <div className="d-flex align-items-center mb-2">
                            <span className="date-text text-black">
                              <img
                                src={CalenderImg}
                                alt="calendar"
                                className=""
                              />
                              {formatSingleDate(ele.start_date)} -{" "}
                              {formatSingleDate(ele.end_date)}
                            </span>
                          </div>
                          <div className="influencer-home-brand-name">
                            <div className="brand-name">
                              <p>{ele?.brand_name}</p>
                            </div>
                          </div>
                          <span className="location-text">
                            {locations?.length > 0 && (
                              <img
                                src={LocationImg}
                                className="img-fluid me-1"
                                alt="location"
                              />
                            )}

                            {/* Display first 3 states */}
                            {states?.slice(0, 3)?.map((state, index) => (
                              <span key={index} className="location-text ms-2">
                                {state}
                              </span>
                            ))}

                            {/* State +count */}
                            {states?.length > 3 && (
                              <Tooltip
                                title={states?.slice(3)?.join(", ")}
                                arrow
                              >
                                <Chip
                                  className="plus-count-chip"
                                  style={{
                                    fontSize: "11px",
                                    fontFamily: "Poppins, sans-serif",
                                    margin: "2px",
                                    height: "25px",
                                    width: "43px",
                                    backgroundColor: "#6B8E76",
                                    color: "#fff",
                                    cursor: "pointer",
                                  }}
                                  label={`+${states.length - 3}`}
                                  variant="outlined"
                                />
                              </Tooltip>
                            )}
                            <br />
                            {/* Display first 3 cities */}
                            {/* {cities
                                                            .slice(0, 3)
                                                            .map((city, index, arr) => (
                                                              <span
                                                                key={index}
                                                                className="location-text mr-5"
                                                              >
                                                                {city}
                                                                {index < arr.length - 1 ? ", " : ""}
                                                              </span>
                                                            ))} */}
                            {/* City +count */}
                            {/* {cities.length > 3 && (
                                                            <Tooltip
                                                              title={cities.slice(3).join(", ")}
                                                              arrow
                                                            >
                                                              <Chip
                                                                className="plus-count-chip"
                                                                style={{
                                                                  fontSize: "11px",
                                                                  fontFamily: "Poppins, sans-serif",
                                                                  margin: "2px",
                                                                  height: "25px",
                                                                  width: "43px",
                                                                  backgroundColor: "#6B8E76",
                                                                  color: "#fff",
                                                                  cursor: "pointer",
                                                                }}
                                                                label={`+${cities.length - 3}`}
                                                                variant="outlined"
                                                              />
                                                            </Tooltip>
                                                          )} */}
                          </span>
                          <hr />
                          <div className="mb-3">
                            <p className="mb-2">Deliverables</p>
                            <div className="language-container d-flex flex-wrap mt-2">
                              {ele.language &&
                                ele.language.length > 0 &&
                                (() => {
                                  const visibleLanguages = ele.language.slice(
                                    0,
                                    3
                                  );
                                  const hiddenLanguages = ele.language.slice(3);

                                  return (
                                    <>
                                      {visibleLanguages.map((lang, index) => (
                                        <Tooltip
                                          key={index}
                                          title={lang.name}
                                          arrow
                                        >
                                          <span className="language-tag me-2">
                                            {lang.short_name}
                                          </span>
                                        </Tooltip>
                                      ))}

                                      {hiddenLanguages.length > 0 && (
                                        <Tooltip
                                          title={hiddenLanguages
                                            .map((lang) => lang.name)
                                            .join(", ")}
                                          arrow
                                        >
                                          <Chip
                                            style={{
                                              fontSize: "11px",
                                              fontFamily: "Poppins, sans-serif",
                                              margin: "2px 6px 5px 0",
                                              height: "25px",
                                              backgroundColor: "#6B8E76",
                                              color: "#fff",
                                              cursor: "pointer",
                                            }}
                                            label={`+${hiddenLanguages.length}`}
                                            variant="outlined"
                                          />
                                        </Tooltip>
                                      )}
                                    </>
                                  );
                                })()}
                            </div>
                          </div>
                        </div>
                        <button onClick={() => ViewDetails(ele.campaign_id)}>
                          Insights
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === "completed" && completedCampaigns?.length > 0 && (
              <div className="row g-4 completed-campigns">
                {completedCampaigns?.map((ele) => {
                  const cities = Array.isArray(ele.city)
                    ? ele.city
                    : typeof ele.city === "string"
                      ? [ele.city]
                      : [];

                  const states = Array.isArray(ele.state)
                    ? ele.state
                    : typeof ele.state === "string"
                      ? [ele.state]
                      : [];

                  const locations = cities.map((city, index) => ({
                    city,
                    state: states[index] || "",
                  }));
                  return (
                    <div
                      key={ele.campaign_id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      <div className="campaign-card">
                        <div className="influencer-home-image">
                          <img
                            src={ele.campaign_poster || DummyImg}
                            alt={ele.campaign_title}
                            className="campaign-image w-100"
                          />
                        </div>
                        <div className="p-3">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="StatusCamp">
                              <h5 className="mb-1">{ele.campaign_title}</h5>
                              <span className="status">
                                <span></span>Completed
                              </span>
                            </div>
                          </div>
                          <p className="mb-2">{ele.campaign_obj}</p>
                          <div className="d-flex align-items-center mb-2">
                            <span className="date-text">
                              <img
                                src={CalenderImg}
                                className="img-fluid"
                                alt="calendar"
                              />
                              {formatSingleDate(ele.start_date)} -{" "}
                              {formatSingleDate(ele.end_date)}
                            </span>
                          </div>

                          <hr />
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Product Name
                            </div>
                            <div className="text-black">
                              {ele.product_name || "-"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Budget
                            </div>
                            <div className="text-black fw-medium">
                              {ele?.budget && !isNaN(ele.budget)
                                ? new Intl.NumberFormat("en-IN", {
                                    style: "currency",
                                    currency: "INR",
                                  }).format(ele.budget)
                                : "N/A"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Deliverables
                            </div>
                            <div>
                              <div className="d-flex">
                                {(() => {
                                  const firstWeek =
                                    ele.timeline && ele.timeline.length > 0
                                      ? ele.timeline[0]
                                      : null;

                                  const hasInstagramContent =
                                    firstWeek &&
                                    firstWeek.Instagram &&
                                    (firstWeek.Instagram.reels > 0 ||
                                      firstWeek.Instagram.posts > 0 ||
                                      firstWeek.Instagram.story > 0);

                                  const hasYouTubeContent =
                                    firstWeek &&
                                    firstWeek.YouTube &&
                                    (firstWeek.YouTube.shorts > 0 ||
                                      firstWeek.YouTube.videos > 0 ||
                                      firstWeek.YouTube.live_stream > 0);

                                  return (
                                    <>
                                      {hasInstagramContent && (
                                        <div className="campaign-image-container me-3">
                                          <img
                                            src={instaDeliverables}
                                            alt="Instagram"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}

                                      {hasYouTubeContent && (
                                        <div className="campaign-image-container">
                                          <img
                                            src={youtubeDeliverables}
                                            alt="YouTube"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "5px",
                          }}
                        >
                          <button onClick={handleAddDeliverablesClick}>
                            Add Deliverables Link
                          </button>{" "}
                          {/* <button
                            onClick={() => Insights(ele.campaign_id)}
                            style={{
                              flex: 1,
                              padding: "8px 8px", // Smaller padding
                              fontSize: "14px", // Smaller font size
                            }}
                          >
                            Insights
                          </button>
                          <button
                            onClick={() => ViewDetails(ele.campaign_id)}
                            style={{
                              flex: 1,
                              padding: "8px 8px", // Smaller padding
                              fontSize: "14px", // Smaller font size
                            }}
                          >
                            Details
                          </button> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {activeTab === "completed" && completedCampaigns?.length === 0 && (
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center px-4 max-w-md mx-auto">
                  <div>
                    <img
                      src={NoCamp}
                      alt="No Campaigns"
                      className="object-contain"
                    />
                  </div>
                  <h2 className="Title">Welcome to the Insights!</h2>
                  <p className="text-gray-blank-600 mb-8">
                    It looks like you don't have any completed campaigns yet.
                  </p>
                  <button
                    onClick={() => createNavigate()}
                    className="CreateGreenBtn"
                  >
                    Create new Campaign
                    <img src={create} className="img-fluid" alt="Create Icon" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          {activeTab === "completed" && completedCampaigns?.length === 0 && (
            <div
              className="min-h-screen flex items-center justify-center bg-gray-50"
              style={{ marginTop: "95px" }}
            >
              <div className="text-center px-4 max-w-md mx-auto">
                <div>
                  <img
                    src={emptyinsights}
                    alt="No Campaigns"
                    className="object-contain"
                  />
                </div>
                <h2 className="Title">Welcome to the Insights!</h2>
                <p className="text-gray-blank-600 mb-8">
                  Start by creating your first campaign to connect with your
                  audience!
                </p>
                {/* <button onClick={() => createNavigate()} className="CreateGreenBtn">
                    Create new Campaign
                    <img src={create} className="img-fluid" alt="Create Icon" />
                  </button> */}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
